<template>
  <div class="main">
    <h1>Clients dashboard</h1>
  </div>
</template>

<script>
export default {

}
</script>

<style>

</style>
